import { render, staticRenderFns } from "./coupon_pill.vue?vue&type=template&id=4054090d&"
import script from "./coupon_pill.vue?vue&type=script&lang=js&"
export * from "./coupon_pill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports